/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSpecialHourResponse } from './GetSpecialHourResponse';
import {
    GetSpecialHourResponseFromJSON,
    GetSpecialHourResponseFromJSONTyped,
    GetSpecialHourResponseToJSON,
    GetSpecialHourResponseToJSONTyped,
} from './GetSpecialHourResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetSpecialHourResponse
 */
export interface PaginatedResultOfGetSpecialHourResponse {
    /**
     * 
     * @type {Array<GetSpecialHourResponse>}
     * @memberof PaginatedResultOfGetSpecialHourResponse
     */
    items?: Array<GetSpecialHourResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetSpecialHourResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetSpecialHourResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetSpecialHourResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetSpecialHourResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetSpecialHourResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetSpecialHourResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetSpecialHourResponse interface.
 */
export function instanceOfPaginatedResultOfGetSpecialHourResponse(value: object): value is PaginatedResultOfGetSpecialHourResponse {
    return true;
}

export function PaginatedResultOfGetSpecialHourResponseFromJSON(json: any): PaginatedResultOfGetSpecialHourResponse {
    return PaginatedResultOfGetSpecialHourResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetSpecialHourResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetSpecialHourResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetSpecialHourResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetSpecialHourResponseToJSON(json: any): PaginatedResultOfGetSpecialHourResponse {
    return PaginatedResultOfGetSpecialHourResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetSpecialHourResponseToJSONTyped(value?: PaginatedResultOfGetSpecialHourResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetSpecialHourResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

